import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { ReduxState } from "../../../redux";
import { useTour } from "./TourContext";
import {
  SEGMENT_DEMO_TOURS,
  ONBOARDING_TOUR,
  DEMO_TOUR_OTHER,
  SUB_TOURS
} from "./tourDefinitions";

/**
 * Registers all tour definitions and auto-starts the right tour:
 * - Sandbox mode → segment-specific demo tour
 * - First real login (no prior tour) → onboarding tour
 */
const TourLauncher: React.FC = () => {
  const { registerTour, startTour, state } = useTour();
  const { isSandboxMode, token } = useSelector((state: ReduxState) => state.Auth);
  const segment = (token as any)?.sandboxSegment || (token as any)?.segment || "other";

  // Register all tours on mount
  useEffect(() => {
    Object.values(SEGMENT_DEMO_TOURS).forEach(registerTour);
    Object.values(SUB_TOURS).forEach(registerTour);
    registerTour(ONBOARDING_TOUR);
  }, []);

  // Auto-start tour based on mode
  useEffect(() => {
    if (state.active) return; // already in a tour

    if (isSandboxMode) {
      const demoDef = SEGMENT_DEMO_TOURS[segment] || DEMO_TOUR_OTHER;
      startTour(demoDef.id);
    }
    // Note: onboarding tour for first-time real users is started externally
    // (e.g. from the getting-started checklist component) to avoid conflicts
  }, [isSandboxMode, segment]);

  return null;
};

export default TourLauncher;
